import * as Yup from 'yup';
import passwordResetModel from '../models/passwordResetModel';

const {
  formField: {
    password,
    confirmPassword
  }
} = passwordResetModel;

const passwordResetSchema = {
    [password.name]: Yup.string()
        .required(`${password.requiredErrorMsg}`)
        .min(8, `${password.invalidErrorMsg}`),
    [confirmPassword.name]: Yup.string()
        .required(`${confirmPassword.requiredErrorMsg}`)
        .oneOf([Yup.ref(password.name)], `${confirmPassword.invalidErrorMsg}`)
};

export default passwordResetSchema
